<template>
  <div v-dompurify-html="message"/>
</template>
<script>
import { innerChatMixin } from 'mixins'

/**
 * Отображение отформатированного сообщения из чата (с учетом тего)
 */
export default {
  name: 'innerChatMessage',
  mixins: [innerChatMixin],
  data() {
    return {
      message: null,
    }
  },
  methods: {
    setEvent(type, params) {
      this.$root.$emit('clickTagItem', {type, params})
      this.$emit('clickTag', {type, params})
    },
    createClick() {
      const clickItems = document.querySelectorAll('[mode="click"]')
      if (clickItems?.length) {
        const that = this
        clickItems.forEach((clickItem) => {
          if (!this.readonly) {
            clickItem.classList.add('pointer')
            clickItem.addEventListener('click', () => {
              const type = clickItem.getAttribute('type')
              const params = {}

              var attributes = clickItem.attributes
              for (var k = 0; k < attributes.length; k++) {
                if (new RegExp(/props_/g).test(attributes[k].nodeName)) {
                  params[attributes[k].nodeName.replace('props_','')] = attributes[k].nodeValue
                }
              }
              that.setEvent(type, params)
            })
          }
        })
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue && newValue || (JSON.stringify(newValue) !==  JSON.stringify(oldValue))) {
          this.message = this.$_convertMessage(newValue, this.readonly)
          this.$nextTick(() => {
            this.createClick()
          })
        }
      }
    }
  },
  props: {
    /**
    * Объект с данными
    */
    value: {
      type: Object
    },
    /**
     * Только просмотр. Без событий
    */
    readonly: {
      type: Boolean,
    }
  },
}
</script>
